module.exports = __webpack_public_path__ + "img/back.20966d6f.png";